import { useTranslation } from 'react-i18next';
import { FormItem, Radio, RadioButton } from '../Ant';

interface CustomerOptionSelectorProps {
  currentStepOption: string | undefined;
  onChange: (newOption: 'existing' | 'new') => void;
}

const CustomerOptionSelector: React.FC<CustomerOptionSelectorProps> = ({
  currentStepOption,
  onChange,
}) => {
  const { t } = useTranslation();
  return (
    <FormItem label={t('matterRequest:selectCustomerOption')}>
      <RadioButton
        value={currentStepOption}
        onChange={(e) => onChange(e.target.value as 'existing' | 'new')}
      >
        <Radio value="existing">{t('matterRequest:existingCustomer')}</Radio>
        <Radio value="new">{t('matterRequest:newCustomer')}</Radio>
      </RadioButton>
    </FormItem>
  );
};

export default CustomerOptionSelector;
